module.exports = __webpack_public_path__ + "media/application/images/2018/my-consumer-edit-bbd079983b70a204386e5bc7a0557d3b.png";